export default __webpack_public_path__ + "static/media/calendar.bff9ca1d.svg";